import auth from '@/router/auth'
import CategoryItemIndex from '@/components/levels/Index'
import CategoryItemCreate from '@/components/levels/Create'
import CategoryItemUpdate from '@/components/levels/Update'
import CategoryItemShow from '@/components/levels/Show'

export default [
  {
    path: '/levels',
    name: 'levels-index',
    component: CategoryItemIndex,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/levels/create',
    name: 'levels-create',
    component: CategoryItemCreate,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/levels/update/:level_id',
    name: 'levels-update',
    component: CategoryItemUpdate,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/levels/show/:level_id',
    name: 'levels-show',
    component: CategoryItemShow,
    beforeEnter: auth.requireAuth
  }
]



// WEBPACK FOOTER //
// ./src/components/levels/router.js